export default __webpack_public_path__ + "static/media/1.a3f54de5.png";